import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CLOUDN_COLORS } from "../../../constants/colors";
import PublicStyledTableCell from "../../publics/PublicStyledTableCell";
import AllDeviceOverallTableRow from "../../atoms/all/AllDeviceOverallTableRow";
import AllDeviceModal from "./AllDeviceModal";
import { useEffect, useState } from "react";
import {
  AllDeviceModalType,
  AllDeviceOverallTableProps,
} from "../../../constants/types";

const AllDeviceOverallTable = (props: AllDeviceOverallTableProps) => {
  const [rows, setRows] = useState<JSX.Element[]>([]);
  // const [modal, setModal] = useState<AllDeviceModalType>({
  //   modal: false,
  //   data: {
  //     status: false,
  //     no: 0,
  //     projectName: "",
  //     category: "",
  //     id: "",
  //     name: "",
  //     lastDate: "",
  //     note: "",
  //   },
  // });

  // useEffect(() => {
  //   setRows(
  //     props.data.map((data, index) => (
  //       <AllDeviceOverallTableRow key={index} data={data} setModal={setModal} />
  //     ))
  //   );
  // }, [props.data]);

  useEffect(() => {
    const list = props.data
      .slice(props.page.state * 30, props.page.state * 30 + 30)
      .map((data, index) => (
        <AllDeviceOverallTableRow data={data} key={index} />
      ));
    setRows(list);
  }, [props.data, props.page.state]);
  return (
    <>
      <TableContainer
        sx={{
          width: "100%",
          height: "87%",
          borderBottom: `2px solid ${CLOUDN_COLORS.logoSkyBlue}`,
        }}
      >
        <Table
          style={{
            width: "100%",
            borderSpacing: 0,
          }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <PublicStyledTableCell>통신상태</PublicStyledTableCell>
              <PublicStyledTableCell>번호</PublicStyledTableCell>
              <PublicStyledTableCell>프로젝트명</PublicStyledTableCell>
              <PublicStyledTableCell>구분</PublicStyledTableCell>
              <PublicStyledTableCell>ID</PublicStyledTableCell>
              <PublicStyledTableCell>기기명 (판넬명)</PublicStyledTableCell>
              <PublicStyledTableCell>
                마지막 통신 데이터 시간
              </PublicStyledTableCell>
              <PublicStyledTableCell>비고</PublicStyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{rows}</TableBody>
        </Table>
      </TableContainer>
      {/* {modal.modal && <AllDeviceModal data={modal.data} setModal={setModal} />} */}
    </>
  );
};

export default AllDeviceOverallTable;
